import cx from 'classnames';

import { JS_CLASS_NAMES } from '@/utils/constants';

import { Container } from '@/components/container';

import css from './burger.module.scss';

// type Props = {
//   onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
//   debug?: any;
//   fixed?: boolean;
//   isOpen: boolean;
//   forwardedRef?:
//     | string
//     | React.RefObject<HTMLDivElement>
//     | ((instance: HTMLDivElement | null) => void)
//     | null
//     | undefined;
// };

const Burger = ({ onClick, isOpen, fixed = true }) => {
  return (
    <div
      className={cx(css.burgerWrapper, JS_CLASS_NAMES.withPreventScrollOffset, {
        [css.fixed]: fixed,
      })}
    >
      <Container className={css.burgerContainer}>
        <div className={css.burgerButtonWrapper}>
          <button className={css.burgerButton} onClick={onClick} type="button" aria-label="Бургер">
            <div className={cx(css.burgerDash, isOpen && css.opened)} />
            <div className={cx(css.burgerDash, isOpen && css.opened)} />
            <div className={cx(css.burgerDash, isOpen && css.opened)} />
          </button>
        </div>
      </Container>
    </div>
  );
};

export default Burger;
